// NotFound.tsx
import { useI18N } from "common/hooks";
import NoSearchResultsFilter from "@/assets/images/noresultsfilter.svg";
import { Link } from "@tanstack/react-router";
import { StandardButton } from "@/components/common/StandardButton";

function NotFound() {
  const i18n = useI18N();

  return (
    <div className="flex flex-col items-center justify-center flex-1 mt-20">
      <img
        src={NoSearchResultsFilter}
        alt="Page not found"
        className="max-w-[50%]"
      />
      <p className="mt-6 mx-auto text-center title-m-bold text-fg-neutral-strong">
        {i18n.get("noPageFound")}
      </p>
      <p className="text-center max-w-[80%] md:max-w-[60%] title-s-semibold text-fg-neutral-strong">
        {i18n.get("bitLostMessagePage")}
      </p>

      <Link to="/" role="button">
        <StandardButton variant="primary" size="lg" className="mt-4 px-6 py-3">
          <span className="text-center title-s-semibold">
            {i18n.get("gotoHomePage")}
          </span>
        </StandardButton>
      </Link>
    </div>
  );
}

export default NotFound;
